module.exports = __webpack_public_path__ + "img/expostyle_1339_lavender_pantone2573c.302cbb5c.jpg";